<div class="footer">
    <ul class="footer-list">
        <li class="footer-item">
            <p class="m-0 footer-item-link rights">&copy; {{ currentYear }} Sprintax</p>
        </li>
        <li class="footer-item">
            <a
                class="footer-item-link"
                href="https://www.sprintax.com/privacy-policy/"
                target="_blank">
                Privacy Policy
            </a>
        </li>
        <li class="footer-item">
            <a
                class="footer-item-link"
                href=" https://www.sprintax.com/cookie-policy/"
                target="_blank">
                Cookie Policy
            </a>
        </li>
        <li class="footer-item">
            <a
                class="footer-item-link"
                href="https://www.sprintax.com/terms-and-conditions/"
                target="_blank">
                Terms and Conditions
            </a>
        </li>
        <li class="footer-item">
            <a
                class="footer-item-link"
                href="https://www.sprintax.com/security-policy/"
                target="_blank">
                Security Policy
            </a>
        </li>
        <li class="footer-item">
            <a
                class="footer-item-link"
                href="https://www.sprintax.com/quality-policy/"
                target="_blank">
                Quality Policy
            </a>
        </li>
    </ul>
</div>
